import { AnnouncementListResponseType } from "@sellar-io/api-v2/types";
import { useNavigate } from "react-router";
import { getAnnouncementNavigationUrl } from "./notificationNavigation.helper";
import { useAnnouncementReadCreate } from "../../hooks/api/v2/announcementRead/useAnnouncementReadCreate";
import { NotificationGroupContent } from "./NotificationGroupContent";

export const NotificationAnnouncementGroup = ({
  announcement,
  setPopoverActive,
  isNotificationPopover,
}: {
  announcement: AnnouncementListResponseType[number];
  setPopoverActive?: (active: boolean) => void;
  isNotificationPopover: boolean;
}) => {
  const navigate = useNavigate();
  const mutation = useAnnouncementReadCreate();
  const SenderBusiness = announcement.SenderBusiness;
  const navigateToOrderPage = () => {
    return navigate(getAnnouncementNavigationUrl(announcement));
  };
  const markAsRead = () => {
    // for not there is only order notifications. We will need to update this in the future
    // to handle different notification types
    if (!!announcement.AnnouncementRead) {
      navigateToOrderPage();
      return setPopoverActive?.(false);
    }
    mutation.mutate(
      {
        AnnouncementId: announcement.id,
      },
      {
        onSuccess: () => {
          navigateToOrderPage();
          setPopoverActive?.(false);
        },
      },
    );
  };

  const logoUrl = SenderBusiness.logoUrl;
  const senderBusinessName = SenderBusiness.name;
  const title = announcement.title;
  const description = announcement.description;
  const isNotificationRead = !!announcement.AnnouncementRead;
  return (
    <NotificationGroupContent
      isNotificationRead={isNotificationRead}
      description={description}
      title={title}
      senderBusinessName={senderBusinessName}
      logoUrl={logoUrl}
      markAsRead={markAsRead}
      isNotificationPopover={isNotificationPopover}
    />
  );
};
